import { cn } from "@/lib/utils";

const TONE = { green: "bg-emerald-500 shadow-[0_0_0_6px_rgba(16,185,129,0.18)]", yellow: "bg-amber-400 shadow-[0_0_0_6px_rgba(251,191,36,0.2)]", red: "bg-[#F92626] shadow-[0_0_0_6px_rgba(249,38,38,0.18)] animate-pulse", grey: "bg-slate-300" };
export const LIGHT_WORDS = { green: "All good", yellow: "Not connected yet", red: "Needs you", grey: "Paused" };

export function Light({ tone = "grey", size = "md", testId }) {
  return <span data-testid={testId} aria-label={LIGHT_WORDS[tone]} className={cn("inline-block shrink-0 rounded-full", size === "lg" ? "h-5 w-5" : size === "sm" ? "h-2.5 w-2.5" : "h-3.5 w-3.5", TONE[tone] || TONE.grey)} />;
}

export function Big({ children, className, testId }) {
  return <div data-testid={testId} className={cn("text-2xl font-extrabold tracking-tight text-[#101C47] sm:text-3xl", className)}>{children}</div>;
}

export function StepDots({ step, total }) {
  return <div className="flex items-center gap-2" data-testid="connect-step-dots">{Array.from({ length: total }, (_, i) => <span key={i} className={cn("h-2.5 rounded-full transition-all duration-300", i === step ? "w-8 bg-[#101C47]" : i < step ? "w-2.5 bg-emerald-500" : "w-2.5 bg-slate-200")} />)}</div>;
}
